import type { ReactNode } from "react";
import { useIsTenantAdmin } from "../hooks/useIsTenantAdmin";

type AdminOnlyProps = {
	children: ReactNode;
	/** Shown once the check finds the user isn't a tenant admin. */
	fallback?: ReactNode;
};

/**
 * Renders its children only for admins of the user's tenant, and nothing
 * while that's being checked.
 *
 * This used to check for a Skylight or Saffron email address, which can't
 * tell a clinic's admins from its daily users: they sign in with the same
 * clinic accounts. The role now comes from the tenant membership.
 */
export function AdminOnly({ children, fallback = null }: AdminOnlyProps) {
	const isTenantAdmin = useIsTenantAdmin();

	if (isTenantAdmin === undefined) {
		return null;
	}

	return <>{isTenantAdmin ? children : fallback}</>;
}
